import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

type Variant = "fixed" | "inline";

export function AppMenu({ variant }: { variant: Variant }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const handleRefresh = () => {
    window.dispatchEvent(new Event("skt:refresh-data"));
    setMenuOpen(false);
  };

  const overlay = menuOpen && (
    <>
      <button
        type="button"
        className="nav-backdrop"
        aria-label="關閉選單"
        onClick={() => setMenuOpen(false)}
      />
      <nav
        className={
          variant === "inline" ? "nav-drawer nav-drawer--centered" : "nav-drawer"
        }
        onClick={() => setMenuOpen(false)}
      >
        <Link to="/" className={location.pathname === "/" ? "active" : ""}>
          是日金價
        </Link>
        <Link
          to="/chart"
          className={location.pathname === "/chart" ? "active" : ""}
        >
          7 天走勢
        </Link>
        <Link
          to="/admin"
          className={location.pathname === "/admin" ? "active" : ""}
        >
          後台
        </Link>
        <button type="button" className="nav-action" onClick={handleRefresh}>
          重新讀取資料
        </button>
      </nav>
    </>
  );

  const btn = (
    <button
      type="button"
      className={`menu-toggle ${variant === "inline" ? "menu-toggle--inline" : ""}`}
      aria-expanded={menuOpen}
      aria-label={menuOpen ? "關閉選單" : "開啟選單"}
      onClick={() => setMenuOpen((o) => !o)}
    >
      {menuOpen ? "✕" : "☰"}
    </button>
  );

  if (variant === "inline") {
    return (
      <div className="app-menu-inline">
        {overlay}
        {btn}
      </div>
    );
  }

  return (
    <footer className="app-menu-footer">
      {overlay}
      {btn}
    </footer>
  );
}
